import { render, staticRenderFns } from "./ClientesVendedorPresentaciones.vue?vue&type=template&id=29dc9fee&scoped=true"
import script from "./ClientesVendedorPresentaciones.vue?vue&type=script&lang=js"
export * from "./ClientesVendedorPresentaciones.vue?vue&type=script&lang=js"
import style0 from "./ClientesVendedorPresentaciones.vue?vue&type=style&index=0&id=29dc9fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc9fee",
  null
  
)

export default component.exports